export default __webpack_public_path__ + "static/media/prestashop.deb3c3c4.png";